import ShowroomTabs from './showroom-tabs';

export default ShowroomTabs;